import styled from "@emotion/styled";

export const StyledCrewTransferHint = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 30px;
`;
